import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { chatroomId: Number }

  connect() {
    this.selectedSupplierId = null
    this.selectedSupplierName = null
  }

  toggle(event) {
    const chatroomId = this.chatroomIdValue
    const section = document.getElementById(`supplier_search_section_${chatroomId}`)

    if (section) {
      // Toggle simple con display
      if (section.style.display === 'none' || section.classList.contains('collapse')) {
        section.style.display = 'block'
        section.classList.remove('collapse')
        // Enfocar el input
        const input = section.querySelector('input[type="text"]')
        if (input) input.focus()
      } else {
        section.style.display = 'none'
        section.classList.add('collapse')
      }
    }
  }

  handleSupplierClick(event) {
    // Interceptar clicks en los resultados del supplier-search
    const supplierResult = event.target.closest('.supplier-assignment-search-result')
    if (supplierResult) {
      event.preventDefault()
      event.stopPropagation()

      const supplierId = supplierResult.dataset.supplierId
      const supplierName = supplierResult.dataset.supplierName

      // Guardar la selección
      this.selectedSupplierId = supplierId
      this.selectedSupplierName = supplierName

      // Actualizar el input con el nombre seleccionado
      const input = document.getElementById(`supplier_search_${this.chatroomIdValue}`)
      if (input) {
        input.value = supplierName
      }

      // Habilitar el botón de asignación
      this.updateAssignButton(true)

      // Cerrar el dropdown
      const results = document.getElementById(`supplier_search_results_${this.chatroomIdValue}`)
      if (results) {
        results.classList.add('d-none')
      }
    }
  }

  updateAssignButton(enabled) {
    const button = document.getElementById(`assign_supplier_btn_${this.chatroomIdValue}`)
    if (button) {
      button.disabled = !enabled
      if (enabled) {
        button.classList.remove('btn-secondary')
        button.classList.add('btn-primary')
      } else {
        button.classList.remove('btn-primary')
        button.classList.add('btn-secondary')
      }
    }
  }

  assignSelectedSupplier(event) {
    if (this.selectedSupplierId && this.selectedSupplierName) {
      this.assignSupplier(this.selectedSupplierId, this.selectedSupplierName)
    }
  }

  async assignSupplier(supplierId, supplierName) {
    const chatroomId = this.chatroomIdValue

    // Mostrar loading
    const resultsContainer = document.getElementById(`supplier_search_results_${chatroomId}`)
    if (resultsContainer) {
      resultsContainer.textContent = ''
      const loadingDiv = document.createElement('div')
      loadingDiv.className = 'text-center py-3'
      const spinner = document.createElement('div')
      spinner.className = 'spinner-border spinner-border-sm text-primary me-2'
      loadingDiv.appendChild(spinner)
      loadingDiv.appendChild(document.createTextNode('Asignando proveedor...'))
      resultsContainer.appendChild(loadingDiv)
    }

    try {
      const response = await fetch(`/chatrooms/${chatroomId}/assign_supplier`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({ supplier_id: supplierId })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      Turbo.renderStreamMessage(html)

      // Solo limpiar si la respuesta fue exitosa
      if (response.ok) {
        // Limpiar la selección
        this.selectedSupplierId = null
        this.selectedSupplierName = null

        // Limpiar el input
        const input = document.getElementById(`supplier_search_${chatroomId}`)
        if (input) {
          input.value = ''
        }

        // Deshabilitar el botón
        this.updateAssignButton(false)

        // Cerrar la sección
        const section = document.getElementById(`supplier_search_section_${chatroomId}`)
        if (section) {
          section.style.display = 'none'
          section.classList.add('collapse')
        }
      }
    } catch (error) {
      if (resultsContainer) {
        resultsContainer.textContent = ''
        const alertDiv = document.createElement('div')
        alertDiv.className = 'alert alert-danger d-flex justify-content-between align-items-center'
        const contentDiv = document.createElement('div')
        const icon = document.createElement('i')
        icon.className = 'fas fa-exclamation-triangle me-2'
        contentDiv.appendChild(icon)
        const strong = document.createElement('strong')
        strong.textContent = 'Error: '
        contentDiv.appendChild(strong)
        contentDiv.appendChild(document.createTextNode(' No se pudo asignar el proveedor. Intenta nuevamente.'))
        alertDiv.appendChild(contentDiv)
        const closeButton = document.createElement('button')
        closeButton.type = 'button'
        closeButton.className = 'close'
        closeButton.textContent = '×'
        closeButton.onclick = () => alertDiv.remove()
        alertDiv.appendChild(closeButton)
        resultsContainer.appendChild(alertDiv)
      } else {
        console.error('Results container not found!')
        // Fallback: mostrar alert en el frontend
        const section = document.getElementById(`supplier_search_section_${chatroomId}`)
        if (section) {
          const errorDiv = document.createElement('div')
          errorDiv.className = 'alert alert-danger alert-dismissible fade show'
          const icon = document.createElement('i')
          icon.className = 'fas fa-exclamation-triangle me-2'
          errorDiv.appendChild(icon)
          const strong = document.createElement('strong')
          strong.textContent = 'Error: '
          errorDiv.appendChild(strong)
          errorDiv.appendChild(document.createTextNode(' No se pudo asignar el proveedor. Intenta nuevamente.'))
          const closeButton = document.createElement('button')
          closeButton.type = 'button'
          closeButton.className = 'close'
          closeButton.textContent = '×'
          closeButton.onclick = () => errorDiv.remove()
          errorDiv.appendChild(closeButton)
          section.appendChild(errorDiv)
        }
      }
    }
  }
}
